import { getData, getElement } from "../helpers";
import { BankModal } from "../views/settings/settings/banks/modals/store";

class ButtonBank extends HTMLButtonElement {
    connectedCallback() {
        this.test();
        this.load();
        this.events();
    }

    test() {
        // No borrar este método, pero sí su contenido
    }

    load() {
        //
    }

    events() {
        this.addEventListener("click", (e) => {
            BankModal.create(
                getData(this, "data-bs-target"),
                getData(this, "title"),
                getData(this, "data-url")
            );
        });

        document.addEventListener("aj:select2", (e) => {
            if (getData(this, "data-bank") == "customer") {
                let data = e.detail.data;
                this.setAttribute(
                    "data-url",
                    getData(this, "data-customer-url") + data.slug
                );
            }
        });
    }
}

window.customElements.define("button-bank", ButtonBank, {
    extends: "button",
});
